export const empty = () => {
  return;
};

export const asyncEmpty = () => Promise.resolve();
